import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function Login() {
  const { login, error } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const ok = await login(email, password);
    setLoading(false);
    if (ok) navigate("/admin");
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4" data-testid="login-page">
      <div className="w-full max-w-md uf-card p-8">
        <p className="text-xs tracking-[0.3em] uppercase text-[#FF6B1A] mb-3">Espace organisation</p>
        <h1 className="font-display text-4xl mb-8">CONNEXION ADMIN</h1>

        <form onSubmit={submit} className="space-y-4" data-testid="login-form">
          <label className="block">
            <span className="text-xs tracking-[0.2em] uppercase font-bold text-white/60 mb-2 block">Email</span>
            <input
              type="email"
              required
              className="uf-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="login-email"
            />
          </label>
          <label className="block">
            <span className="text-xs tracking-[0.2em] uppercase font-bold text-white/60 mb-2 block">Mot de passe</span>
            <input
              type="password"
              required
              className="uf-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="login-password"
            />
          </label>

          {error && (
            <p className="text-[#FF3B30] text-sm" data-testid="login-error">
              {error}
            </p>
          )}

          <button type="submit" disabled={loading} className="btn-brutal w-full" data-testid="login-submit">
            {loading ? "Connexion…" : "Se connecter"}
          </button>
        </form>
      </div>
    </div>
  );
}
